define('ET/ETModel',[
    "evertrue",
    "jquery",
    "underscore",
    "backbone"
], function ETModelFactory ( EverTrue, $, _, Backbone) {
    // Extend the bacbone Model with our EverTrue model w/ defualt functionality
    var ETModel = Backbone.Model.extend({
        url : window.url,
        // function that processes the response from api requests
        parse : EverTrue.Parser,
        sync : EverTrue.sync,
        initialize : function(){
            var view = this;
            if (this.useLocalStorage !== false) {
                this.on('sync', function(data){
                    view.saveToStorage();
                },this);
            }
        },
        saveToStorage : function(){
            var key = this.urlRoot;
            if (_.isFunction(this.urlRoot)){
                key = this.urlRoot();
            }
            key = this.storageName || key;
            EverTrue.amplify(key, this.toJSON());
        },
        hardSet: function ( obj, options ) {
            options = options || {};
            obj = obj || {};

            options.forceUpdate = true;

            this.clear({silent: true});
            // set the object (should be an object with id key set)
            if (!_.isEmpty(obj)){
                this.set(obj, {silent: true});
            }

            return this.fetch(options);
        },
        forceUpdate : function(options){
            options = options || {};
            options.forceUpdate = true;
            return this.fetch(options);
        },
        // function to get from localstorage instantly - no settimeout
        retrieve : function(){
            if (_.isFunction(this.urlRoot)){
                this.urlRoot = this.urlRoot();
            }
            var store = EverTrue.amplify(this.storageName || this.urlRoot);
            if (store) this.set(store, {silent : true});
        },
    });
    ETModel.include = EverTrue.include;
    return ETModel;

});

